export enum OneClickElement {
  TERMS_AND_CONDITIONS = 'termsAndConditions',
  ORDER_VALIDITY = 'orderValidity',
}
